import React, { useState } from "react";
import { useParams } from "react-router-dom";

import {
    CalendarDays,
    MapPin,
    Building2,
    Users,
    ArrowRight,
    Library,
    BookOpen,
    BriefcaseBusiness,
    Monitor,
    BookMarked,
    Newspaper,
    FileText,
    GlassWater,
    Accessibility,
    RefreshCw,
    Clock3,
    Phone,
    Route,
 UserRound,
} from "lucide-react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
const LibraryFacility = ({ icon, title }) => {
    return (
        <div className="group flex items-center gap-4 p-5 bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300">

            <div className="shrink-0 w-11 h-11 rounded-xl bg-[#fff1ef] text-[#F04B3A] flex items-center justify-center group-hover:bg-[#F04B3A] group-hover:text-white transition-colors duration-300">
                {icon}
            </div>

            <p className="text-[15px] font-medium text-[#24364b] leading-6">
                {title}
            </p>

        </div>
    );
};
const CollectionItem = ({ label, value }) => {
    return (
        <div className="flex items-center justify-between gap-4 p-4 rounded-xl bg-white/10 border border-white/10 hover:bg-white/15 transition-all duration-300">
            <span className="text-white/80 text-sm leading-5">
                {label}
            </span>

            <span className="shrink-0 text-white font-bold text-sm bg-[#F04B3A] px-3 py-1.5 rounded-lg">
                {value}
            </span>
        </div>
    );
};
const InfrastructureFacilitiesPage = () => {
const { slug } = useParams();
// console.log("Current slug:", slug);
const [active, setActive] = useState(false);
const [showCollection, setShowCollection] = useState(true);

switch (slug) {


case "hostel":
return (
<div className="min-h-screen bg-[var(--paper)]">
    <Header />
    {/* HERO */}
    <section className="relative h-[250px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                    {/* <span>Home</span> */}
                    {/* <span>/</span> */}
                    <span className="text-[#123B5D] text-lg font-gill">
                        About
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                         Infrastructure And Facilities
                    </span>
                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        Hostel
                    </span>
                </div>

                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                <h1 className="text-4xl md:text-4xl font-bold leading-tight text-[#064E3B]">
                    HOSTELS
                </h1>

                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
            </div>
        </div>
    </section>
    {/* HIGHLIGHTS */}
    <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">

            <div className="text-center max-w-1xl mx-auto mb-12">

   <h3 className="text-center text-2xl font-bold text-[#123B5D]">
    Hostels at DSB Campus, Nainital
</h3>

            </div>

            <div className="grid md:grid-cols-3 gap-6">

                {/* ================= director1 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                relative
                                w-40 h-40
                                rounded-full
                                flex items-center justify-center
                                bg-[#EAF5EF]
                                border-4 border-[#0B5D3B]/10
                                shadow-sm
                                group-hover:shadow-lg
                                group-hover:bg-[#0B5D3B]
                                transition-all duration-300
                            "
                        >
                            <i
                                className="
                                     fa-solid fa-hotel
                                    text-[#e0171b]
                                    text-6xl
                                    group-hover:text-white
                                    transition-all duration-300
                                "
                            ></i>
                        </div>

                 </div>


                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                     Saheed Bhagat Singh Hostel (Boys)
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                               <strong>Warden: </strong>Dr. P. Chaniyal
                            </p>
                        </div>

                         <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9690659365</p>
                        </div>

                    </div>


                </div>

                {/* ================= director1 end ================= */}

  {/* ================= director3 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                relative
                                w-40 h-40
                                rounded-full
                                flex items-center justify-center
                                bg-[#EAF5EF]
                                border-4 border-[#0B5D3B]/10
                                shadow-sm
                                group-hover:shadow-lg
                                group-hover:bg-[#0B5D3B]
                                transition-all duration-300
                            "
                        >
                            <i
                                className="
                                     fa-solid fa-hotel
                                    text-[#e0171b]
                                    text-6xl
                                    group-hover:text-white
                                    transition-all duration-300
                                "
                            ></i>
                        </div>

                 </div>
                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                    Chandra Shekha Azad Hostel (Boys)
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                               <strong> Warden:</strong>Dr. S. Kumar
                            </p>
                        </div>

                        {/* <div className="flex items-start gap-3">
                            <i className=" fa-solid fa-hotel-columns text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>  Political Science Department</p>
                        </div>

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-envelope text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>neetaborasharma@yahoo.com</p>
                        </div> */}
                         <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>7579252592</p>
                        </div>

                    </div>


                </div>

                {/* ================= director2 end ================= */}

                 {/* ================= director2 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                     <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                relative
                                w-40 h-40
                                rounded-full
                                flex items-center justify-center
                                bg-[#EAF5EF]
                                border-4 border-[#0B5D3B]/10
                                shadow-sm
                                group-hover:shadow-lg
                                group-hover:bg-[#0B5D3B]
                                transition-all duration-300
                            "
                        >
                            <i
                                className="
                                     fa-solid fa-hotel
                                    text-[#e0171b]
                                    text-6xl
                                    group-hover:text-white
                                    transition-all duration-300
                                "
                            ></i>
                        </div>

                 </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                    K. C. Pant Hostel (Boys)
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                                <strong>Warden:</strong>Dr. S. Kumar
                            </p>
                        </div>

                        
                         <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>7579252592</p>
                        </div>

                    </div>


                </div>

                {/* ================= director3 end ================= */}

                 {/* ================= director4 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                relative
                                w-40 h-40
                                rounded-full
                                flex items-center justify-center
                                bg-[#EAF5EF]
                                border-4 border-[#0B5D3B]/10
                                shadow-sm
                                group-hover:shadow-lg
                                group-hover:bg-[#0B5D3B]
                                transition-all duration-300
                            "
                        >
                            <i
                                className="
                                     fa-solid fa-hotel
                                    text-[#e0171b]
                                    text-6xl
                                    group-hover:text-white
                                    transition-all duration-300
                                "
                            ></i>
                        </div>

                 </div>
                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                    Rani Laxmi Hostel (Girls)
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                                <strong>Warden: </strong>Dr. R. Singh
                            </p>
                        </div>

                         <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p> 05942-235438, 9719599661</p>
                        </div>

                    </div>


                </div>

                {/* ================= director4 end ================= */}

    {/* ================= director4 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                     <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                relative
                                w-40 h-40
                                rounded-full
                                flex items-center justify-center
                                bg-[#EAF5EF]
                                border-4 border-[#0B5D3B]/10
                                shadow-sm
                                group-hover:shadow-lg
                                group-hover:bg-[#0B5D3B]
                                transition-all duration-300
                            "
                        >
                            <i
                                className="
                                     fa-solid fa-hotel
                                    text-[#e0171b]
                                    text-6xl
                                    group-hover:text-white
                                    transition-all duration-300
                                "
                            ></i>
                        </div>

                 </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                 Kamla Pant Hostel (Girls)
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                                <strong>Warden:</strong> Dr. H. Lohini
                            </p>
                        </div>

                       
                         <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p> 05942-235650, 9897681666</p>
                        </div>

                    </div>


                </div>

                {/* ================= director4 end ================= */}

{/* ================= director5 start================= */}
                <div
                    className="group relative bg-white rounded-2xl p-8
                  border border-gray-200 shadow-md
                  hover:shadow-xl transition-all duration-300
                  overflow-hidden">

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                     <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                relative
                                w-40 h-40
                                rounded-full
                                flex items-center justify-center
                                bg-[#EAF5EF]
                                border-4 border-[#0B5D3B]/10
                                shadow-sm
                                group-hover:shadow-lg
                                group-hover:bg-[#0B5D3B]
                                transition-all duration-300
                            "
                        >
                            <i
                                className="
                                     fa-solid fa-hotel
                                    text-[#e0171b]
                                    text-6xl
                                    group-hover:text-white
                                    transition-all duration-300
                                "
                            ></i>
                        </div>

                 </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                  Gaura Devi Hostel (Girls)
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                                <strong>Warden:</strong>Dr. A. Kumari
                            </p>
                        </div>

                        
                         <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>05942-235171, 9410517012</p>
                        </div>

                    </div>


                </div>

                {/* ================= director5 end ================= */}

           
              
            </div>
        </div>
    </section>
    {/* ================= ORGANOGRAM SECTION ================= */}
<section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">

            <div className="text-center max-w-1xl mx-auto mb-12">

   <h3 className="text-center text-2xl font-bold text-[#123B5D]">
    Hostels at Technical Campus, Bhimtal
</h3>

            </div>

            {/* <div className="grid md:grid-cols-3 gap-6 justify-center"> */}
           <div className="flex flex-wrap justify-center gap-6 items-stretch">

                {/* ================= director1 start================= */}
                <div
    className="
        group relative bg-white rounded-2xl p-8
        border border-gray-200 shadow-md
        hover:shadow-xl transition-all duration-300
        overflow-hidden
        w-full md:w-[400px]
        min-h-[430px]
        flex flex-col
    "
>

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                    <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                relative
                                w-40 h-40
                                rounded-full
                                flex items-center justify-center
                                bg-[#EAF5EF]
                                border-4 border-[#0B5D3B]/10
                                shadow-sm
                                group-hover:shadow-lg
                                group-hover:bg-[#0B5D3B]
                                transition-all duration-300
                            "
                        >
                            <i
                                className="
                                     fa-solid fa-hotel
                                    text-[#e0171b]
                                    text-6xl
                                    group-hover:text-white
                                    transition-all duration-300
                                "
                            ></i>
                        </div>

                 </div>


                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                     Babu JagJeewan Ram Hostel (Boys)
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                               <strong>Warden: </strong>Dr. T. Kumar
                            </p>
                        </div>

                         <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9412124396</p>
                        </div>

                    </div>


                </div>

                {/* ================= director1 end ================= */}

  

                 {/* ================= director2 start================= */}
               <div
    className="
        group relative bg-white rounded-2xl p-8
        border border-gray-200 shadow-md
        hover:shadow-xl transition-all duration-300
        overflow-hidden
        w-full md:w-[400px]
        min-h-[430px]
        flex flex-col
    "
>

                    {/* Decorative Shape */}
                    <div
                        className="absolute -top-10 -left-10 w-32 h-32
                    rounded-full bg-[#EAF5EF]
                     group-hover:bg-[#88bfe1]
                    transition-all duration-300">
                    </div>

                    {/* Icon */}
                    {/* Photo */}
                     <div className="relative w-40 h-40 mb-7 flex items-center justify-center">

                        <div
                            className="
                                relative
                                w-40 h-40
                                rounded-full
                                flex items-center justify-center
                                bg-[#EAF5EF]
                                border-4 border-[#0B5D3B]/10
                                shadow-sm
                                group-hover:shadow-lg
                                group-hover:bg-[#0B5D3B]
                                transition-all duration-300
                            "
                        >
                            <i
                                className="
                                     fa-solid fa-hotel
                                    text-[#e0171b]
                                    text-6xl
                                    group-hover:text-white
                                    transition-all duration-300
                                "
                            ></i>
                        </div>

                 </div>

                    <h3
                        className="text-xl font-bold text-[#123B5D] mb-4
                   group-hover:text-[#0B5D3B] transition-colors">
                    Kalpna Chawla Hostel (Girls)
                    </h3>
                    <div className="space-y-3 text-[15px] text-[hsl(241,85%,39%)]">

                        <div className="flex items-start gap-3">
                            <i className="fa-solid fa-user-tie text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>
                                <strong>Warden:</strong> Prof. V. Pande
                            </p>
                        </div>

                        
                         <div className="flex items-start gap-3">
                            <i className="fa-solid fa-phone text-[#E52323] text-[17px] mt-1 w-4"></i>
                            <p>9412419725</p>
                        </div>

                    </div>


                </div>

                {/* ================= director3 end ================= */}

             
           
              
            </div>
        </div>
    </section>
    <Footer />

</div>
);

case "medical-facilities":
return (
<div className="min-h-screen bg-[var(--paper)]">
    <Header />

    {/* HERO */}
    <section className="relative h-[300px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-6 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-5">
                    {/* <span>Home</span> */}
                    {/* <span>/</span> */}
                    <span className="text-[#123B5D] text-lg font-gill">
                        About
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                       Infrastructure And Facilities
                    </span>
                     <span className="text-[#123B5D] text-lg font-gill">
                        /
                    </span>

                    <span className="text-[#123B5D] text-lg font-gill">
                       Medical Facilities
                    </span>
                </div>

                {/* <p className="uppercase tracking-[0.25em] text-sm text-[var(--saffron)] font-gill mb-4">
                    Kumaun University
                </p> */}

                <h1 className="text-4xl md:text-6xl font-bold leading-tight text-[#064E3B] text-lg font-gill">
                   MEDICAL FACILITIES
                </h1>

                {/* <p className="mt-5 text-lg text-[#123B5D] max-w-2xl text-justify">
                    Discover the history, vision, campuses and academic
                    excellence of Kumaun University.
                </p> */}
            </div>
        </div>
    </section>

    {/* STATS */}


    {/* ABOUT CONTENT */}
    <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-14 items-center">

            {/* IMAGE */}
            <div className="relative">
                <div className="absolute -left-5 -bottom-5 w-full h-full rounded-3xl bg-[var(--saffron)]/20" />

                <img src="/images/medical-facilities.jpg" alt="Kumaun University Campus"
                    className="relative w-full h-[430px] object-cover rounded-3xl shadow-xl" />
            </div>

            {/* CONTENT */}
            <div>
                

                <h2 className="text-3xl md:text-4xl font-bold  text-[var(--terracotta)] mb-6  font-gill">
                    Medical Facilities at Kumaun University
                </h2>

                <p className="text-gray-600 leading-8 mb-5 text-justify text-lg font-gill">
                  The University has teamed up with leading district hospitals to provide swift medical care for students. Operating a dedicated ambulance van, the University ensures prompt transportation of ailing students to these affiliated hospitals. Additionally, on-campus first aid services are available to address immediate medical needs. These facilities offer initial care for minor injuries or health concerns, emphasizing the University's commitment to the well-being of its students by guaranteeing access to essential medical services and support when required.
                </p>

               
            </div>

        </div>
    </section>
  <section className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-6">

          

            <div className="space-y-5 text-[16px] leading-7 text-gray-700 text-justify">
                <h2 className="text-3xl md:text-4xl font-bold  text-[var(--terracotta)] mb-6  font-gill">
                   Medical Care and Insurance
                </h2>

                  <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-7">

                <div className="flex items-center gap-4 bg-gradient-to-r from-[#067a23] to-[#1c607d] px-2 py-2">


                    <div>
                        <h3 className="text-xl md:text-1xl font-bold text-white text-justify font-gill">
                       The students are covered by comprehensive Medical Insurance to meet any untoward exigencies. The students covered under insurance are entitled to the following facilities:
                        </h3>

                    </div>
                </div>

                <div className="p-2 md:p-2">

                    <div className="space-y-4 text-justify text-lg font-gill">

                        {[
                        "Every student is insured for medical claim (hospitalization) for Rs. 75,000/-and medical claim(daycare) for Rs.10,000/- subject to the terms and the conditions of the policy.",

                        "The hospitalization claims of students within the scope of policy coverage are reimbursed. Reimbursement facility is also available if the treatment is taken in non empanelled hospitals.",
                        "Insurance cover operates 24 hours even out of the campus and at all places in India.",
                        "Nominated parents of students are covered against personal accident insurance of Rs. 2,50,000/-(as per policy terms). To give umbrella security to students against the exigencies of accidental death and permanent disability of his parents the amount is released to the student concerned to defray expenses to complete the course of study with the University.",
                        


                        ].map((item, index) => (
                        <div key={index}
                            className="group flex items-start gap-4 p-4 rounded-xl bg-[#f8faf9] border border-gray-100 hover:border-[#d6a84f] hover:bg-[#fffdf7] transition-all duration-300">

                            <div
                                className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#176b4d] text-white flex items-center justify-center font-gill group-hover:bg-[#d6a84f] transition">
                                {index + 1}
                            </div>

                            <p className="text-gray-700 leading-7 pt-0.5">
                                {item}
                            </p>

                        </div>
                        ))}

                    </div>
                </div>
            </div>
                

            </div>
        </div>
    </section>
    
   
    <Footer />

</div>

);
case "himalayan-museum":
    return (
<div className="min-h-screen bg-[var(--paper)]">
    <Header />

    {/* HERO */}
    <section className="relative h-[300px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-4 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-2">
                    <span className="text-[#123B5D] text-lg font-gill">
                      About
                    </span>
                      <span className="text-[#123B5D] text-lg font-gill">
                      /
                    </span>
                   <span className="text-[#123B5D] text-lg font-gill">
                         Infrastructure And Facilities
                    </span>
                      <span className="text-[#123B5D] text-lg font-gill">
                      /
                    </span>
                   <span className="text-[#123B5D] text-lg font-gill">
                        Himalayan Museum
                    </span>
                </div>

               

                <h1 className="text-4xl md:text-6xl font-bold leading-tight text-[#064E3B] font-gill">
                    HIMALAYA MUSEUM
                </h1>

             
            </div>
        </div>
    </section>

    {/* STATS */}
    

    {/* ABOUT CONTENT */}
    <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-14 items-center">

            {/* IMAGE */}
          <div className="relative">
    <div className="absolute -left-5 -bottom-5 w-full h-full rounded-3xl bg-[var(--saffron)]/20" />

    <img
        src="/images/himalaya-museum-about-img.png"
        alt="Central Library"
        className="relative w-full h-auto object-contain rounded-3xl shadow-xl"
    />
</div>

            {/* CONTENT */}
            <div>
                <h2 className="uppercase tracking-[0.2em] text-2xl md:text-3xl font-bold text-[var(--terracotta)] mb-3 font-gill">
                   About the Himalaya Museum
                </h2>

                {/* <h2 className="text-3xl md:text-4xl font-bold text-[var(--ink)] mb-6">
                   UNIVERSITY AT A GLANCE
                </h2> */}

                <p className="text-gray-600 leading-8 mb-5 text-justify text-lg font-gill">
                  The Himalaya Museum was established in 1987 under the auspices of the Department of History, Kumaun University, Nainital. It was inaugurated by Prof. Yashpal, the then Chairman of the University Grants Commission. Since its inception the museum has been actively involved in the task of collection, compilation recording, and documentation. It has put up many important exhibitions in various places, including the university campus, and has organized a number of seminars and conferences, the assistance of the Department of History.
                </p>

              
            </div>

        </div>
    </section>
    {/* card section add vision of library start  */}
    {/* VISION & OBJECTIVES */}
<section className="py-12 px-6 bg-[var(--paper)]">
  <div className="max-w-6xl mx-auto px-4 text-lg font-gill">
     <h6>The Museum building exhibits important document related not only to the archaeology and History of Uttarakhand but also to its folk literature, regional journalism, agricultural implements, coins, household articles, musical instruments, Personality, People, Documents and the independence movements.</h6>
   <div className="grid lg:grid-cols-2 gap-8 items-start">
   
    {/* LEFT SIDE - VISION */}
    <div className="text-lg font-gill">
       

        <LibraryAccordion
            title="Statues and Veerkhambs (Victory Pillars)"
            items={[
                "Statues dating back from the 2nd century BC to the 15th century AD. These includes statues of the four-armed Ganesha, the four-armed Vishnu, the two armed Sun God, the four-armed Varah, Navgrah etc. The Museum also houses Several (Victory Stones) Veerkhambs.",
            ]}
        />
<br/>
        <LibraryAccordion
            title="About Coins"
            items={[
                "Approximately 300 coins, including a gold coins dating back to the Kushana period, numerous coins from the Kushana period, numerous coins from the medieval and modern periods and also some coins from other countries",
            ]}
        />
<br/>
        <LibraryAccordion
            title="About Agricultural implements"
            items={[
                "Including a plough, danela, yoke, millstone etc.",
            ]}
        />
<br/>
        <LibraryAccordion
            title="About Household articles"
            items={[
                "Various household articles which were commonly used in the region including a wooden kneading dish or pavo, bisavo, daunkali, thhinka, a mackintosh fashioned out of malu leaves, wooden casks or thhekis, used for storing ghee and salt.",
            ]}
        />
<br/>
        <LibraryAccordion
            title="About Folk Musical instruments"
            items={[
                "including local drums, dhols, damau, toori, ransinga, hurka etc.",
            ]}
        />
    </div>


    {/* RIGHT SIDE - OBJECTIVES */}
    <div>
        

        <LibraryAccordion
            title="About Maskes"
            items={[
                "A complete set of masks, used during the folk festival hiljatra, the farra or shield used during the pashan- yuddha (stonepelting festival) at Devidhura.",
            ]}
        />
        <br/>
        <LibraryAccordion
            title="About Regional and National newspapers"
            items={[
                "Miscellaneous Issues of Almora Akhbar, Shakti, Garhwali Swadheen Praja, Karmabhoomi, Tarun Kumaun, Harijan Sewak, Young India, Hindi Navjeevan and the complete files of the Parvateeya.",
            ]}
        />
        <br/>
        <LibraryAccordion
            title="About Manuscripts"
            items={[
                "Rishi Tarpan Paddhati, Harivansh Purana, Yagheshwar Mahatmya, Ramganga Mahatmya, Shiv Purana etc.",
            ]}
        />
        <br/>
       <LibraryAccordion
            title="About Weapons"
            items={[
                "Shield and sword belonging to the Chand dynasty, shield and sword used during at chholiya dance.",
            ]}
        />
        <br/>
        <LibraryAccordion
            title="About Pictorial Collection"
            items={[
                "Approximately 1000 photographs dealing with the biodiversity, rock carvings, society, culture, folk art, regional, journalism, the freedom movements, Tamra patras (Copper Plates), temples, places and the people of Uttarakhand and with Mahatama Gandhi visit to Kumaun.",
            ]}
        />
        <br/>
        {/* <LibraryAccordion
            title="About Pictorial Collection"
            items={[
                "Approximately 1000 photographs dealing with the biodiversity, rock carvings, society, culture, folk art, regional, journalism, the freedom movements, Tamra patras (Copper Plates), temples, places and the people of Uttarakhand and with Mahatama Gandhi visit to Kumaun.",
            ]}
        />
        <br/> */}
    </div>

</div>
</div>
</section>
    {/* card section add vision of library end  */}
{/* layout section start */}
<section className="py-12 px-6 bg-[var(--paper)]">
    
    <div className="max-w-7xl mx-auto">
   <h5 className="text-2xl md:text-3xl font-bold mb-5 text-[#F04B3A] font-gill">
    A Museum's Historical Insight
</h5>
 <p className="mb-5 text-justify text-lg font-gill">
    Therefore, a visit to the museum will provide visitors with a panoramic view of Uttarakhand’s march of development, from ancient times to the modern age.
</p>
        <div className="grid lg:grid-cols-3 gap-6">

            {/* OPENING TIME CARD */}
            <div className="bg-[#066c53] rounded-lg p-8 md:p-10 shadow-lg">

                <h2 className="text-2xl font-bold text-white mb-6 font-gill">
                    Opening Time:
                </h2>

                <ul className="space-y-4 text-white text-[16px] leading-7">

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl">
                            ●
                        </span>
                        <span className="text-lg font-gill">
                            10:30 AM - 1:00 PM &amp; 1:30 PM - 4:00 PM
                        </span>
                    </li>

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl">
                            ●
                        </span>
                        <span className="text-lg font-gill">
                            Museum will close on Sunday and other holidays
                            mentioned in University Academic Calender.
                        </span>
                    </li>

                </ul>
            </div>


            {/* CONTACT CARD */}
            <div className="bg-[#043465] rounded-lg p-8 md:p-10 shadow-lg">

                <h2 className="text-2xl font-bold text-white mb-6 font-gill">
                    Contact:
                </h2>

                <ul className="space-y-4 text-white text-[16px] leading-7">

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl">
                            ●
                        </span>
                        <span className="text-lg font-gill">
                            Dr. Heera Singh Bhakuni
                        </span>
                    </li>

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl">
                            ●
                        </span>
                        <span className="font-gill">
                            9759892471
                        </span>
                    </li>

                </ul>
            </div>


            {/* ROUTE CARD */}
            <div className="bg-[#066c53] rounded-lg p-8 md:p-10 shadow-lg">

                <h2 className="text-2xl font-bold text-white mb-6 font-gill">
                    Route:
                </h2>

                <ul className="space-y-4 text-white text-[16px] leading-7">

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold">
                            1.
                        </span>

                        <span className="text-lg font-gill">
                            From Mallital Flats to Rajbhawan Road at D.S.B.
                            Campus by Taxi or on foot.
                        </span>
                    </li>

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold">
                            2.
                        </span>

                        <span className="text-lg font-gill">
                            From Tallital Bus Stand via Fansi Gadhera on foot.
                        </span>
                    </li>

                </ul>
            </div>

        </div>

    </div>
</section>

   
  
   <section className="py-2 bg-[#f5f7fb] overflow-hidden">
    <div className="max-w-6xl mx-auto px-2">

        {/* Heading */}
        <div className="mb-4">
            {/* <span className="text-sm font-gill tracking-[0.2em] uppercase text-[#e21b1b]">
                Our Library
            </span> */}

            <h2 className="mt-2 text-3xl md:text-4xl font-bold text-[#08245c] font-gill">
                Museum Gallery
            </h2>

            <div className="mt-3 w-16 h-1 bg-[#e21b1b] rounded-full"></div>
        </div>

        {/* ================= MARQUEE ================= */}
        <div className="relative overflow-hidden">

            <div className="library-marquee">

                {/* FIRST SET */}
                <div className="library-track">

                    <div className="gallery-item">
                        <img
                            src="/images/Museum-5.png"
                            alt="Library"
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/pandav-nratya.png"
                            alt="Library"
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/rock-paintings.png"
                            alt="Library"
                        />
                    </div>

                   

                </div>


                {/* DUPLICATE SET - SEAMLESS LOOP */}
                {/* <div className="library-track" aria-hidden="true">

                    <div className="gallery-item">
                        <img
                            src="/images/central-library2.jpeg"
                            alt=""
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/central-library3.jpeg"
                            alt=""
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/central-library4.jpeg"
                            alt=""
                        />
                    </div>

                  

                </div> */}

            </div>

        </div>
    </div>


    {/* ================= MARQUEE CSS ================= */}
    <style>{`
       
        .library-track {
            display: flex;
            gap: 24px;
            padding-right: 24px;
        }

        .gallery-item {
            width: 350px;
            height: 225px;
            flex-shrink: 0;
            overflow: hidden;
            border-radius: 12px;
            background: white;
            box-shadow: 0 6px 18px rgba(0,0,0,0.10);
            border: 1px solid rgba(8,36,92,0.08);
        }

        .gallery-item img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
            transition: transform 0.5s ease;
        }

        .gallery-item:hover img {
            transform: scale(1.06);
        }

        .library-marquee:hover {
            animation-play-state: paused;
        }

        @keyframes libraryScroll {
            from {
                transform: translateX(0);
            }

            to {
                transform: translateX(-50%);
            }
        }

        @media (max-width: 768px) {
            .gallery-item {
                width: 260px;
                height: 195px;
            }

            .library-track {
                gap: 16px;
                padding-right: 16px;
            }

            .library-marquee {
                animation-duration: 22s;
            }
        }
    `}</style>

</section>
    <Footer />

</div>

);











default:
return (
<div className="min-h-screen flex items-center justify-center">
    <h1 className="text-3xl font-bold">
        Page Not Found
    </h1>
</div>
);
}
};

const LibraryAccordion = ({ title, items }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="border border-[#f59aaa] rounded-xl bg-white overflow-hidden">

            {/* CARD HEADER */}
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center justify-between px-5 py-5 text-left"
            >
                <h2 className="text-[18px] md:text-[20px] font-bold text-[#002b6b]">
                    {title}
                </h2>

                {/* PLUS / MINUS */}
                <span className="text-[#002b6b] text-2xl font-bold leading-none">
                    {isOpen ? "−" : "+"}
                </span>
            </button>


            {/* CARD CONTENT */}
            {isOpen && (
                <div className="px-5 pb-6">

                    <div className="border-t border-[#f3c4cb] pt-5">

                        <ul className="space-y-4 text-gray-800 text-[15px] md:text-[16px] leading-7">

                            {items.map((item, index) => (
                                <li
                                    key={index}
                                    className="flex items-start gap-3"
                                >
                                    <span className="text-[#F04B3A] font-bold text-xl leading-7">
                                        »
                                    </span>

                                    <span>
                                        {item}
                                    </span>
                                </li>
                            ))}

                        </ul>

                    </div>

                </div>
            )}

        </div>
    );
};
/* STAT COMPONENT */

const Stat = ({ icon, value, label }) => {
return (
<div className="p-6 text-center border-b md:border-b-0 md:border-r last:border-0">
    <div className="flex justify-center text-[var(--terracotta)] mb-3">
        {icon}
    </div>

    <div className="text-2xl font-bold text-[var(--ink)]">
        {value}
    </div>

    <div className="text-sm text-gray-500 mt-1">
        {label}
    </div>
</div>
);
};


/* HIGHLIGHT COMPONENT */

const Highlight = ({ title, text }) => {
return (
<div className="p-7 rounded-2xl border border-[var(--cream-deep)] bg-[var(--paper)] hover:shadow-lg transition">
    <h3 className="text-xl font-bold text-[var(--ink)] mb-3">
        {title}
    </h3>

    <p className="text-gray-600 leading-7">
        {text}
    </p>
</div>
);

};

export default InfrastructureFacilitiesPage;
